import styled from 'styled-components';
import { designTokens } from '../foundation/DesignTokens';

// Base button component following the new design system
export const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${designTokens.spacing.sm};
  padding: 9px 16px;
  border-radius: ${designTokens.radius.full};
  border: none;
  font-family: ${designTokens.fonts.heading};
  font-size: 0.87rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  outline: none;
  white-space: nowrap;
  min-height: 40px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: 900px) {
    font-size: 0.8rem;
    padding: 8px 14px;
    min-height: 36px;
  }
`;

// Primary button variant
export const PrimaryButton = styled(Button)`
  background: ${designTokens.colors.primary[500]};
  color: white;
  box-shadow: 0 8px 20px rgba(44,95,78,0.35);

  &:hover:not(:disabled) {
    background: ${designTokens.colors.primary[600]};
    transform: translateY(-1px);
    box-shadow: 0 10px 26px rgba(44,95,78,0.45);
  }

  &:active {
    transform: translateY(0);
  }
`;

// Soft button variant
export const SoftButton = styled(Button)`
  background: ${designTokens.colors.gray[100]};
  color: ${designTokens.colors.gray[800]};
  border: 1px solid ${designTokens.colors.gray[200]};

  &:hover:not(:disabled) {
    background: white;
    border-color: ${designTokens.colors.gray[300]};
  }
`;

// Ghost button variant
export const GhostButton = styled(Button)`
  background: transparent;
  color: ${designTokens.colors.gray[700]};
  padding-inline: 0;

  &:hover:not(:disabled) {
    background: ${designTokens.colors.gray[50]};
    padding-inline: ${designTokens.spacing.sm};
  }
`;

// Icon button for small actions
export const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: ${designTokens.radius.md};
  border: 1px solid ${designTokens.colors.gray[200]};
  background: white;
  color: ${designTokens.colors.gray[600]};
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover:not(:disabled) {
    background: ${designTokens.colors.gray[50]};
    border-color: ${designTokens.colors.gray[300]};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export default Button;
